export default __webpack_public_path__ + "static/media/nls-logo.5f86de88.png";